import z from "zod";

export const BlockPropertiesSchema = z.object({
  name: z.string(),
  pluralName: z.string(),
  icon: z.string(),
  blockStructure: z.any(),
  apiStructure: z.any().optional(),
  itemsURL: z.string().optional(),
  feedsURL: z.string().optional(),
  categoriesURL: z.string().optional(),
  apiWithoutSearch: z.boolean().optional(),
  nextKey: z.boolean().optional(),
  beta: z.boolean().optional(),
  disabled: z.boolean().optional(),
  dynamicMergetags: z
    .array(z.object({ label: z.string(), value: z.string() }))
    .optional(),
});

export type IBlockProperties = z.infer<typeof BlockPropertiesSchema>;
